export default "__VITE_ASSET__BAF5Qc3a__"